<template>
  <div class="py-5">
        <b-container fluid="md">
               <b-row class="plan_text justify-content-center">
                 <h4 class="abc">SUITE 3309</h4>
               </b-row>
               <b-row class="plan_text justify-content-center">
                 <p>Suite area:  3696 s.f.</p>
                 <p>Terrace/balcony: 668 s.f.</p>
               </b-row>
               <div class="plan_text plan_text_btm">
           
                  <p>Click on each level to see the floor plan. <br>
                  <!-- Click on each room to see the furniture. --></p>
            
               </div>
               <b-row class="plan_btn justify-content-center mt-3">
                    <button @click="changeFloor(1)" :class="isActive1 ? 'activeFloorBtn' : ''">Level 1</button>
                    <button @click="changeFloor(2)" :class="isActive2 ? 'activeFloorBtn' : ''">Level 2</button>
                    <button @click="changeFloor(3)" :class="isActive3 ? 'activeFloorBtn' : ''">Level 3</button>
                    <button @click="changeFloor(0)" :class="isActiveG ? 'activeFloorBtn' : ''">Garage</button>
               </b-row>   
    
             <div class="layout_image_wrap mt-5">
                <transition :name="slideDown ? 'slide-down' : 'slide-up'" mode="out-in">
                    <b-img v-show="isActive3" :src="level3" fluid alt="" class="layout_image" ></b-img>
                </transition>
                <transition :name="slideDown ? 'slide-down' : 'slide-up'" mode="out-in">
                    <b-img v-show="isActive2" :src="level2" fluid alt="" class="layout_image" ></b-img>
                </transition>
                <transition :name="slideDown ? 'slide-down' : 'slide-up'" mode="out-in">
                    <b-img v-show="isActive1" :src="level1" fluid alt="" class="layout_image" ></b-img> 
                </transition>
                <transition :name="slideDown ? 'slide-down' : 'slide-up'" mode="out-in">
                    <b-img v-show="isActiveG" :src="garage" fluid alt="" class="layout_image center_el garage_layout" ></b-img>
                </transition>
            <!-- level 1 buttons -->
                 
                <transition name="fade">
                  <img v-show="isActive1" src="img/plusbtn.png" id="li-Den_final_V1_B" :class="isActive1 ? 'plusbtn' : ''" @click="changeHighlight('li-Den_final_V1_B','1')">
                </transition>
                <transition name="fade">
                  <img v-show="isActive1" src="img/plusbtn.png" id="li-Dining_Living_final_V1_B" :class="isActive1 ? 'plusbtn' : ''" @click="changeHighlight('li-Dining_Living_final_V1_B','1')">
                </transition>
                <transition name="fade">
                  <img v-show="isActive1" src="img/plusbtn.png" id="li-Living_Dining_Kitchen_final_V1_B" :class="isActive1 ? 'plusbtn' : ''" @click="changeHighlight('li-Living_Dining_Kitchen_final_V1_B','1')">
                </transition>
                <transition name="fade">
                  <img v-show="isActive1" src="img/plusbtn.png" id="li-Foyer_final_B" :class="isActive1 ? 'plusbtn' : ''" @click="changeHighlight('li-Foyer_final_B','1')">
                </transition>
                 
            <!-- level 1 buttons -->
            <!-- level 2 buttons  -->
                <transition name="fade">
                  <img v-show="isActive2" src="img/plusbtn.png" id="l2-Bedroom_2_final_V2_B" :class="isActive2 ? 'plusbtn' : ''" @click="changeHighlight('l2-Bedroom_2_final_V2_B','2')">
                </transition>
            <!-- level 2 buttons  -->
            <!-- level 3 buttons  -->
                <transition name="fade">
                  <img v-show="isActive3" src="img/plusbtn.png" id="l3-Terrace_final_V1_B" :class="isActive3 ? 'plusbtn' : ''" @click="changeHighlight('l3-Terrace_final_V1_B','3')">
                </transition>
                <transition name="fade">
                  <img v-show="isActive3" src="img/plusbtn.png" id="l3-Master_final_B" :class="isActive3 ? 'plusbtn' : ''" @click="changeHighlight('l3-Master_final_B','3')">
                </transition>
                <transition name="fade">
                  <img v-show="isActive3" src="img/plusbtn.png" id="l3-Bar_final_B" :class="isActive3 ? 'plusbtn' : ''" @click="changeHighlight('l3-Bar_final_B','3')">
                </transition>
                <transition name="fade">
                  <img v-show="isActive3" src="img/plusbtn.png" id="l3-Bathroom_final_B" :class="isActive3 ? 'plusbtn' : ''" @click="changeHighlight('l3-Bathroom_final_B','3')">
                </transition>
                <!-- <transition name="fade">
                  <img v-show="isActive3" src="img/plusbtn.png" id="l3-patio" :class="isActive3 ? 'plusbtn' : ''" @click="changeHighlight('l3-patio','3')">
                </transition> -->
            <!-- level 3 buttons  -->
            <!-- garage button  -->
                <transition name="fade">
                  <img v-show="isActiveG" src="img/plusbtn.png" id="lg-garage" :class="isActiveG ? 'plusbtn' : ''" @click="changeHighlight('lg-garage','0')">
                </transition>
                <transition name="fade">
                  <img v-show="isActiveG" src="img/plusbtn.png" id="lg-storage" :class="isActiveG ? 'plusbtn' : ''" @click="changeHighlight('lg-storage','0')">
                </transition>
            <!-- garage button  -->
           </div>
        </b-container> 
        <!-- <b-modal v-model="show_l1_den" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center">
                     <b-img class="img-fluid" src="img/3306/den/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/den/1-2.png"></b-img>
                  </div>
                  <div>
                      <b-img class="img-fluid" src="img/3306/den/2-1.png"></b-img>
                      <b-img class="img-fluid" src="img/3306/den/2-2.png"></b-img>
                      <b-img class="img-fluid" src="img/3306/den/2-3.png"></b-img>
                  </div>
                  <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal> -->

        <b-modal v-model="modelShow" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center2" v-for="image in images" :key="image">
                     <vue-load-image>
                      <img class="imgClicked" slot="image" :src="image"/>
                     <!-- <b-img class="img-fluid" :src="image"></b-img> -->
                      <img slot="preloader" src="img/loader.gif"/>
                      <div slot="error">error message</div>
                    </vue-load-image>
                   </div> 
                  <div class="download_btn">
                    <a href="img/3309/BridgeSuite 3309 Floorplans March19.pdf" download>Download The List</a>
                  </div>
                </div>
        </b-modal>

        <!-- <b-modal v-model="show_l1_dining" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center">
                     <b-img class="img-fluid" src="img/3306/diningroom/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/diningroom/1-2.png"></b-img>
                   </div>
                    <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal>

      <b-modal v-model="show_l1_dining" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center">
                     <b-img class="img-fluid" src="img/3306/diningroom/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/diningroom/1-2.png"></b-img>
                   </div>
                    <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal>

       <b-modal v-model="show_l1_bedroom" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center">
                     <b-img class="img-fluid" src="img/3306/bedroom/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/bedroom/1-2.png"></b-img>
                  </div>
                  <div>
                      <b-img class="img-fluid" src="img/3306/bedroom/2-1.png"></b-img>
                      <b-img class="img-fluid" src="img/3306/bedroom/2-2.png"></b-img>
                      <b-img class="img-fluid" src="img/3306/bedroom/2-3.png"></b-img>
                  </div>
                  <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal>

        <b-modal v-model="show_l1_reading" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture reading">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center">
                     <b-img class="img-fluid" src="img/3306/reading/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/reading/1-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/reading/1-3.png"></b-img>
                  </div>
                  <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal>

        <b-modal v-model="show_l2_bedroom" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center">
                     <b-img class="img-fluid" src="img/3306/sec_bedroom/1-1.png"></b-img>
                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/sec_bedroom/2-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/sec_bedroom/2-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/sec_bedroom/2-3.png"></b-img>
                  </div>
                  <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal>

        <b-modal v-model="show_l3_bedroom" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture master_bedroom">                
                  <h5 class="roomname">{{room}}</h5>
                  <div>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/1-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/1-3.png"></b-img>
                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/2-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/2-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/2-3.png"></b-img>
                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/3-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/3-2.png"></b-img>
                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/4-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/4-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/master_bedroom/4-3.png"></b-img>
                  </div>
                  <div class="download_btn">
                    <a href="img/pdf/Full Furniture List.pdf" download>Download The Full Furniture List</a>
                  </div>
                </div>
        </b-modal>

        <b-modal v-model="show_l3_patio" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture patio">                
                  <h5 class="roomname">{{room}}</h5>
                  <div>
                     <b-img class="img-fluid" src="img/3306/patio/1-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/1-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/1-3.png"></b-img>
                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/patio/2-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/2-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/2-3.png"></b-img>
                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/patio/3-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/3-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/3-3.png"></b-img>

                  </div>
                  <div>
                     <b-img class="img-fluid" src="img/3306/patio/4-1.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/4-2.png"></b-img>
                     <b-img class="img-fluid" src="img/3306/patio/4-3.png"></b-img>
                  </div>
                  <div class="download_btn">
                    <a href="img/pdf/Patio Furniture List.pdf" download>Download The Patio Furniture List</a>
                  </div>
                </div>
        </b-modal>


        -->
      <!--
        Garage showcase with video

        <b-modal v-model="show_garage" scrollable centered title="" size="xl" hide-footer>
                <div class="text-center photo_border furniture">                
                  <h5 class="roomname">{{room}}</h5>
                  <div class="text-center"> 
                      <video class="garageVideo" autoplay width="100%" preload="auto" loop="loop" muted="muted" playsinline >
                        <source src="img/garage.mp4" type="video/mp4">
                        bgvideo
                    </video>
                  </div>
                </div>      
        </b-modal> 

      -->



  </div>

</template>

<script>
import VueLoadImage from 'vue-load-image';
export default {
   components: {
    'vue-load-image': VueLoadImage
  },
  data(){
    return {
        button_url: 'img/level1btn.png',
        isActive1: false,
        isActive2: false,
        isActive3: false,
        isActiveG: false,
        level:1,
        slideDown: false,
        slideUp: false,
        level1:'img/3309/Floor Plan/3309-Level-1.png',
        level2:'img/3309/Floor Plan/3309-Level-2.png',
        level3:'img/3309/Floor Plan/3309-Level-3.png',
        garage:'img/garage.png',
        room:'',
        garagephotoshow:false,
        modalShow: false,
        show_l1_den: false,
        show_l1_living: false,
        show_l1_dining: false,
        show_l1_bedroom: false,
        show_l1_reading: false,
        show_l2_bedroom: false,
        show_l3_patio: false,
        show_l3_bedroom: false,
        show_garage: false,
        modelShow: false,
        images:[]
    }
  },
  name: 'Floorplan',
  mounted(){
    this.isActive1 = true;

  },
  methods:{
    resetComp(){
      this.isActive1 = true;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActiveG = false;
      this.level1 = 'img/3309/Floor Plan/3309-Level-1.png';
      this.level2 = 'img/3309/Floor Plan/3309-Level-2.png';
      this.level3 = 'img/3309/Floor Plan/3309-Level-3.png';
    },
    changeFloor(level){
      if(level > this.level){
        this.slideDown = true;
      }else{
        this.slideDown = false;
      }
      if(level == 1){
        this.level1 = 'img/3309/Floor Plan/3309-Level-1.png';
        this.button_url = 'img/level1btn.png';
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
        this.isActiveG = false;
        this.level = 1;
        this.garagephotoshow = false;
      }else if(level == 2){
        this.level2 = 'img/3309/Floor Plan/3309-Level-2.png';
        this.button_url = 'img/level2btn.png';
        this.isActive1 = false;
        this.isActive2 = true;
        this.isActive3 = false;
        this.isActiveG = false;
        this.level = 2;
        this.garagephotoshow = false;
      }else if(level == 3){
        this.level3 = 'img/3309/Floor Plan/3309-Level-3.png';
        this.button_url = 'img/level3btn.png';
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = true;
        this.isActiveG = false;
        this.level = 3;
        this.garagephotoshow = false;
      }else{
        this.garage = 'img/garage.png';
        this.button_url = 'img/garagebtn.png';
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = false;
        this.isActiveG = true;
        this.level = 0;
      }
    },
    changeHighlight(room,level){

       if(level == 1){
       switch(room){
         case "li-Den_final_V1_B": 
          this.room = 'Den'; 
          this.modelShow = true;
          this.images =[
            'img/3309/Images/Den final V1 B.jpg',            
          ]
          break;
         case "li-Dining_Living_final_V1_B": 
          this.room = 'Dining & Living'; 
          this.modelShow = true;
          this.images =[
            'img/3309/Images/Dining Living final V1 B.jpg',            
          ]
          break;
         case "li-Living_Dining_Kitchen_final_V1_B": 
          this.room = 'Living, Dining & Kitchen'; 
          this.modelShow = true;
          this.images =[
            'img/3309/Images/Living Dining Kitchen final V1 B.jpg',            
          ]
          break;
         case "li-Foyer_final_B": 
          this.room = 'Foyer'; 
          this.modelShow = true;
          this.images =[
            'img/3309/Images/Foyer_final B.jpg',            
          ]
          break;
          
       }
     }
    else if(level == 2){

        if(room == 'l2-Bedroom_2_final_V2_B'){ 
          this.room = '2nd Bedroom'; 
          this.images =[
            'img/3309/Images/Bedroom 2 final V2 B.jpg',            
          ]
          this.modelShow = true;
         }
      }
      else if(level == 3){

        if(room == 'l3-Terrace_final_V1_B'){ 
          this.room = 'Terrace'; 
          this.images =[
            'img/3309/Images/Terrace final V1 B.jpg',            
          ]
          this.modelShow = true;
         }else if(room == 'l3-Master_final_B'){ 
          this.room = 'Master Bedroom';
          this.images =[
            'img/3309/Images/Master final B.jpg',            
          ]
          this.modelShow = true;
         }
         else if(room == 'l3-Bar_final_B'){ 
          this.room = 'Bar';
          this.images =[
            'img/3309/Images/Bar final B.jpg',            
          ]
          this.modelShow = true;
         }
         else if(room == 'l3-Bathroom_final_B'){ 
          this.room = 'Master Bathroom';
          this.images =[
            'img/3309/Images/Bathroom final B.jpg',            
          ]
          this.modelShow = true;
         }
      }
      else if(level == 0){

        switch(room){

          case "lg-garage":
          this.room = "Garage";
          this.images =[ 
              "img/3309/Images/3309 Garage.jpg",
            ]
          this.modelShow = true;
          break;

          case "lg-storage":
            this.room = "Storage";
            this.images =[
              "img/3309/Images/Garage Storage.jpg",
            ]
            this.modelShow = true;
        }
      } 
    }
  }
}

</script>

<style>
    .modal-header, .modal-body{
    background-color: black !important;
    border-bottom: none !important;
  }
  .close{
    color: white !important;
    opacity: 1 !important;
  }
  .close:hover{
    color: #525151;
  }
  @media (min-width: 576px){
  .modal-dialog {
    max-width: 960px !important;
    }
  }
  @media (min-width: 992px){
    .modal-xl {
      max-width: 1080px !important;
    }
  }
  @media (min-width: 1200px){
    .modal-xl {
        max-width: 1440px !important;
    }
  }

  .imgClicked{
    max-height: 100%;
    max-width: 100%;
    display: flex;
  }

  .text-center2{
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
<style scoped>

#l3-Bathroom_final_B{
         top: 61%;
    right: 14%;
}
#l3-Bar_final_B{
      top: 53%;
    right: 35%;
}
#l3-Master_final_B{
      top: 12%;
    right: 26%;
}
#l3-Terrace_final_V1_B{
      top: 62%;
    right: 62%;
}
#l2-Bedroom_2_final_V2_B{
  top: 48%;
    right: 12%;
}
#li-Foyer_final_B{
  top: 24%;
    right: 27%;
}
#li-Living_Dining_Kitchen_final_V1_B{
  top: 52%;
    right: 52%;
}
#li-Dining_Living_final_V1_B{
  top: 54%;
    right: 66%;
}

  .fade1-enter-active, .fade1-leave-active {
    transition: opacity .8s;
  }
  .fade1-enter, .fade1-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1.2s ease-in;
  }
  .fade-enter/* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fade-leave-to{
    display: none;
  } 


  .slide-down-enter-active{
    transition: all .8s ease-out;
  }
/*  .slide-down-leave-active{
    transition: all .7s ease-out;
  }*/
  .slide-down-enter{
    transform: translateY(-60px);
    opacity: 0;
  }
/*  .slide-down-leave-to{
    transform: translateY(60px);
    opacity: 0;
  }*/

  .slide-up-enter-active{
    transition: all .8s ease-out;
  }
/*  .slide-up-leave-active{
    transition: all .7s ease-out;
  }*/
  .slide-up-enter{
    transform: translateY(60px);
    opacity: 0;
  }
/*  .slide-up-leave-to{
    transform: translateY(-60px);
    opacity: 0;
  }*/
  .center_el{
    margin: 0 auto;
  }
   .layout_image_wrap{
     position: relative;
   }
   .plan_text h4{
    color: black;
    font-size: 1.7rem;
    margin-bottom: 1%;
   }
   .plan_text p{
     margin: 0% 3%;
     font-size: 1.1rem;
   }
   .plan_text_btm{
    margin-top: 3%;
   }
   .plan_text_btm p{
     margin-top: 0;
     display: flex;
     flex-direction: column;
     align-items: center;
     text-align: left;
   }

   .plan_btn button{
     font-size: 1.1rem; 
     background-color: #979797;
     border:none;
     color: white;
     width: 120px;
     padding: 0.7% 1%;
     margin: 0 1%;
   }
   .plan_btn button:hover{
     background-color: #525151;
   }
   .plan_btn button:focus{
      outline:none !important;
   }
   .plusbtn{
     position: absolute;
     width: 25px;
     animation: plusbtnani 1.8s linear infinite;
   }
   .plusbtn:hover{
      cursor: pointer;
   }
   .activeFloorBtn{
     background-color: #525151 !important;
   }
   .floorplan_photo{
     padding: 5%;
     margin-bottom: -50px;
     background-color: black;
   }
   .floorplan_photo_hide{
     display: none;
   }
   .photo_border{
     border: 1px solid white;
     padding: 5% 5%;
   }
   .roomname{
     margin-bottom: 4%;
   }
   .download_btn{
     margin-top: 4%;
   }
   .download_btn a{
     font-size: 1.1rem; 
     background-color: #a4842d;
     border:none;
     color: white;
     padding: 0.7% 1%;
     margin: 0 1%;
   }
   .download_btn a:hover{
     background-color: #8e6f1c;
     text-decoration: none;
   }
   .download_btn a:focus{
      outline:none !important;
   }
   .garage_layout{
         width: 600px;
    }
   #l1-den{
      top: 45%;
      right: 11.85%;
   }
   .furniture img{
        margin: 1%;
   }
   #l1-livingroom{
      top: 50%;
      right: 27%;
   }
   #l1-dining{
      top: 58.5%;
      right: 46.5%;
   }
   #li-Den_final_V1_B{
      top: 61%;
      right: 87%;
   }
   #l1-reading{
      top: 20%;
      right: 60%;
   }
   #l2-bedroom{
      top: 56%;
      right: 83%;
   }
   #l3-bedroom{
      top: 10%;
      right: 66.5%;
   }
   #l3-patio{
      top: 62%;
      right: 29%;
   }
   #lg-garage{
      top: 43%;
      right: 38%;
   }
   #lg-storage{
      top: 43%;
      right: 69%;
   }
   @keyframes plusbtnani{
    0%{
      transform: scale(1,1);
    }
    50%{
      transform: scale(0.8,0.8);
    }
    100%{
      transform: scale(1,1);
    }

   }
   @media (max-width: 1200px){
    .levelbtn {
        width: 60%;
      }
    .plan_text h4{
        font-size: 1.6rem;
    }
    .plan_text p{
        font-size: 1rem;
    }
    .plan_btn button{
      font-size: 1rem;
    }
    .roomname{
      font-size: 1.2rem;
    }
   }
   @media (max-width:991px){
    .plan_btn button{
       width: 100px;
    }
    .plusbtn{
      width: 22px;
    }
    .garage_layout{
         width: 200px;
    }
   }
   @media (max-width: 850px){
     .roomname{
      font-size: 1rem;
     }
   }
   @media (min-width: 817px) and (max-width: 1200px){
      .reading img{
        height: 200px;
      }
   }
   @media (min-width: 992px) and (max-width: 1276px){
      .patio img{
         width: 30%;
      }
   }
  @media (min-width: 992px) and (max-width: 1199px){
      .master_bedroom img{
          height: 200px;
      }
   }
  @media (min-width: 1200px) and (max-width: 1404px){
      .master_bedroom img{
          height: 250px;
      }
   }

   @media (max-width: 580px){
      .plan_text h4{
        font-size: 1.4rem;
      }
      .plan_text p{
        margin: 0 1%;
        font-size: 0.9rem;
      }
      .plan_btn button{
        width: 80px;
        font-size: 0.9rem;
      }
   }
  @media (max-width: 460px){
      .plan_text h4{
        font-size: 1.3rem;
      }
      .plan_text p{
        margin: 0 1%;
        font-size: 0.8rem;
      }
      .plan_btn button{
        width: 80px;
        font-size: 0.8rem;
      }
      .plusbtn{
        width: 20px;
      }
      .garage_layout{
         width: 170px;
      }
      #lg-garage {
        top: 36%;
        right: 38%;
      }
      #lg-storage {
        top: 36%;
        right: 69%;
      }
   }
  @media (max-width: 410px){
      .plan_text h4{
        font-size: 1.2rem;
      }
      .plan_text p{
        margin: 0 1%;
        font-size: 0.7rem;
      }
      .plan_btn button{
        width: 70px;
        font-size: 0.7rem;
      }
      .plusbtn{
        width: 16px;
      }
   }
    @media (max-width: 320px){
          .plan_text h4{
            font-size: 1rem;
          }
          .plan_text p{
            margin: 0 1%;
            font-size: 0.65rem;
          }
          .plan_btn button{
            width: 60px;
            font-size: 0.65rem;
          }
       }
</style>
